<ng-container *transloco="let t;">
  <form (submit)="onSubmit()" novalidate *ngIf="ratingtype !== null">

    <div class="p-grid">
      <div class="p-col-6">
          <h2>{{ t('common.labels.basedata') }}</h2>
      </div>
      <div class="p-col-6 p-text-right" *ngIf="inEdit !== true">
          <button withRight="admin.ratingtype.edit" pButton (click)="onEdit()" type="button" label="{{ t('common.labels.edit') }}" icon="pi pi-pencil" class="p-button-sm p-mb-2 autofocus"></button>
          <button *ngIf="items.length > 0" pButton type="button" (click)="menu.toggle($event)" icon="pi pi-bars" class="p-button-outlined p-button-secondary p-button-sm p-mb-2 p-ml-2" aria-label="{{ t('common.labels.more_functions') }}"></button>
          <p-menu #menu [popup]="true" [model]="items"></p-menu>
      </div>
      <div class="p-col-6 p-text-right" *ngIf="inEdit === true">
        <app-form-buttons [submitting]="submitting" (cancelled)="onCancel()"></app-form-buttons>
      </div>
    </div>


    <div class="p-grid p-fluid">
      <div class="p-col-12 p-md-6">

        <app-form-control [cid]="'name_de'" [control]="form.get('name_de')" [type]="'input'" [label]="t('common.labels.name_de')" [edit]="inEdit" [basevalue]="ratingtype.getLang('name', transloco.getActiveLang())"></app-form-control>
        <app-form-control [cid]="'name_en'" [control]="form.get('name_en')" [type]="'input'" [label]="t('common.labels.name_en')" [edit]="inEdit" [basevalue]="ratingtype.getLang('name', 'EN')"></app-form-control>
        <app-form-control [cid]="'legend_de'" [control]="form.get('legend_de')" [type]="'textarea'" [label]="t('common.labels.legend_de')" [edit]="inEdit" [basevalue]="ratingtype.getLang('legend', transloco.getActiveLang())"></app-form-control>
        <app-form-control [cid]="'legend_en'" [control]="form.get('legend_en')" [type]="'textarea'" [label]="t('common.labels.legend_en')" [edit]="inEdit" [basevalue]="ratingtype.getLang('legend', 'EN')"></app-form-control>

      </div>
      <div class="p-col-12 p-md-6">

        <app-form-control [cid]="'min_value'" [control]="form.get('min_value')" [type]="'input'" [label]="t('common.labels.min_value')" [edit]="inEdit" [basevalue]="ratingtype.min_value"></app-form-control>
        <app-form-control [cid]="'max_value'" [control]="form.get('max_value')" [type]="'input'" [label]="t('common.labels.max_value')" [edit]="inEdit" [basevalue]="ratingtype.max_value"></app-form-control>
        <app-form-control [cid]="'step'" [control]="form.get('step')" [type]="'slider'" [label]="t('common.labels.step')" [edit]="inEdit" [basevalue]="ratingtype.step" [min]="0.5" [max]="10" [step]="0.5"></app-form-control>

        <app-form-error *ngIf="form.errors?.minMax" [control]="form" [inline]="true"></app-form-error>

      </div>
    </div>

  </form>
</ng-container>
